import { render, staticRenderFns } from "./AiaAgreementCustom.vue?vue&type=template&id=0f8e1620&scoped=true"
import script from "./AiaAgreementCustom.vue?vue&type=script&lang=js"
export * from "./AiaAgreementCustom.vue?vue&type=script&lang=js"
import style0 from "./AiaAgreementCustom.vue?vue&type=style&index=0&id=0f8e1620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8e1620",
  null
  
)

export default component.exports